var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.signConfiguration.firma
      ? _c("div", [
          _vm.signConfiguration.firma.activa !== "Y" &&
          _vm.signConfiguration.firma.activa !== "P"
            ? _c(
                "div",
                { staticClass: "d-flex flex-column align-items-center" },
                [
                  _vm.signConfiguration.estampa
                    ? _c("img", {
                        staticClass: "mb-5",
                        attrs: {
                          src: _vm.signConfiguration.estampa,
                          width: "400px"
                        }
                      })
                    : _vm._e(),
                  _c("br"),
                  _c("p", { staticClass: "message-info mb-4" }, [
                    _vm._v("Firma configurada correctamente")
                  ]),
                  _c("small", [_vm._v("Generando certificado")])
                ]
              )
            : _vm._e(),
          _vm.signConfiguration.firma.activa === "Y"
            ? _c(
                "div",
                { staticClass: "d-flex flex-column align-items-center" },
                [
                  _vm.signConfiguration.estampa
                    ? _c("img", {
                        staticClass: "mb-5",
                        attrs: {
                          src: _vm.signConfiguration.estampa,
                          width: "400px"
                        }
                      })
                    : _vm._e(),
                  _c("br"),
                  _c("p", { staticClass: "message-info mb-4" }, [
                    _vm._v("Firma configurada correctamente")
                  ]),
                  _c("small", [
                    _vm._v(
                      "ID Configuración: " +
                        _vm._s(_vm.signConfiguration.firma.signerUsuario)
                    )
                  ]),
                  _vm.$route.name === "user-profile"
                    ? _c(
                        "div",
                        { staticClass: "w-100 mt-4" },
                        [
                          _c("ConfigureStamp", {
                            attrs: {
                              prefix: "esign7",
                              proveedor: "Esign7",
                              tipoFirma: "firmaAvanzada",
                              user: _vm.user
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm.signConfiguration.firma.activa === "P" &&
              _vm.$route.name === "users-management"
            ? _c("div", [
                _c("h4", [
                  _vm._v(
                    " Firma pendiente de activación, el usuario debe ingresar a su perfil para completar el proceso de registro y enrolamiento "
                  )
                ])
              ])
            : _vm.signConfiguration.firma.activa === "P" &&
              _vm.$route.name === "user-profile"
            ? _c(
                "div",
                [
                  _c("h5", { staticClass: "message my-5" }, [
                    _vm._v(
                      " No cierre sesión o cambie de empresa mientras está en el proceso de enrolamiento "
                    )
                  ]),
                  _c("VerifyIdentity")
                ],
                1
              )
            : _vm._e()
        ])
      : _c(
          "div",
          [
            _vm.$route.name === "user-profile"
              ? _c("div", [
                  _c("p", { staticClass: "message-info" }, [
                    _vm._v(
                      " Sin firma configurada dentro de la empresa, contáctese con su administrador "
                    )
                  ])
                ])
              : _c("ActivateEnrollment", {
                  attrs: {
                    user: _vm.user,
                    signConfiguration: _vm.signConfiguration
                  },
                  on: {
                    signed: function($event) {
                      return _vm.$emit("activate")
                    }
                  }
                })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }